import template from './atm_load_profile.all.html';
import controller from './atm_load_profile.all.controller';
import './atm_load_profile.all.scss';

let ATMLoadProfileAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default ATMLoadProfileAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/all/atm_load_profile.all.component.js